import { ApolloError } from '@apollo/client';

import { DAILY_LIMIT_ERROR_MESSAGE } from '../ui/PromoRollSynthModal/consts';

export const isDailyLimitError = (error: unknown): boolean =>
  error instanceof ApolloError && error.message.includes(DAILY_LIMIT_ERROR_MESSAGE);
